/**
 * @Author: wuyang
 * @Date: 2023/12/29
 * @Description: "暂时先不用"
 */
import { IAtomMethod } from '@/helper/store/createStore'
import { useEffect, useState } from 'react'

import { isEqual } from 'lodash'

export const useAtomMethod = <T extends any>(
	params: IAtomMethod<T> | undefined
) => {
	const [value, setValue] = useState(params?.get())

	useEffect(() => {
		setValue(params?.get())
		const unsub = params?.sub(({ newValue, oldValue }) => {
			if (!isEqual(newValue, oldValue)) {
				setValue(newValue)
			}
		})
		return () => {
			unsub?.()
		}
	}, [params])

	return [value, params?.set] as [T, IAtomMethod<T>['set']]
}
